// @flow
import { useQuery, type QueryResult } from 'react-query';
import { transporterTeams as transporterTeamsApi } from 'common/middleware/api';

import { TeamId } from 'common/models/internal/TeamId';

type Params = { clientId: string, transporterId: string };
type Result = $ReadOnlyArray<TeamId>;

export const fetchTransporterTeams = async ({
    clientId,
    transporterId
}: Params): Promise<Result> => {
    const response = await transporterTeamsApi.fetch({
        clientId,
        transporterId
    });
    return response.teamIds.map(teamId => {
        return TeamId.fromJS(teamId);
    });
};

export default function useTransporterTeams({
    transporterId,
    clientId
}: Params): QueryResult<Result> {
    return useQuery({
        queryKey: ['transporter', transporterId, 'teams', 'all'],
        queryFn: () =>
            fetchTransporterTeams({
                clientId,
                transporterId
            })
    });
}
